import { type SuggestedPromptTile } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { PRIMARY_PROMPTS_COUNT } from './PRIMARY_PROMPTS_COUNT';

export const getPrimaryPrompts: (tiles: SuggestedPromptTile[]) => SuggestedPromptTile[] = (tiles) =>
	tiles.slice(0, PRIMARY_PROMPTS_COUNT);
